import React from "react";
import "../../App.css";
import TbbPartiesReport from "../TbbPartiesReport";

function TbbPartiesReportPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("tbb_parties_report")){
    return;}
  return (
    <div className="page-mr">
      <TbbPartiesReport sessionObject={sessionObject} />
    </div>
  );
}

export default TbbPartiesReportPage;